import { useEffect } from 'react'

export const usePannable = (flowRef: React.RefObject<HTMLDivElement>) => {
    useEffect(() => {
        if (!flowRef.current) {
            return
        }

        const keydownHandler = (e: KeyboardEvent) => {
            if (e.key === ' ') {
                flowRef.current?.classList.add('react-flow__pane_pan_start')
            }
        }

        const keyupHandler = (e: KeyboardEvent) => {
            if (e.key === ' ') {
                flowRef.current?.classList.remove('react-flow__pane_pan_start')
            }
        }

        document.addEventListener('keydown', keydownHandler, false)
        document.addEventListener('keyup', keyupHandler, false)

        return () => {
            document.removeEventListener('keydown', keydownHandler, false)
            document.removeEventListener('keyup', keyupHandler, false)
        }
    }, [flowRef])
}
